import React, {memo, useCallback} from "react";
import {DataLoadingStatus} from "../../../Utils/enums";
import {
    deleteDivisionAttribute,
} from "../../../Utils/queries";
import {DivisionAttribute} from "../../../Utils/response-types";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faTrash} from "@fortawesome/free-solid-svg-icons";

const AttributeRow = ({row, att_list, setDivisionAttributes, setStatus}: {
    row: DivisionAttribute,
    att_list: DivisionAttribute[],
    setDivisionAttributes: (div_id: number, new_attributes: DivisionAttribute[]) => void,
    setStatus: React.Dispatch<React.SetStateAction<DataLoadingStatus>>
}) => {

    const deleteAttribute = useCallback(async () => {
        setStatus(DataLoadingStatus.Loading);
        setDivisionAttributes(row.division_id, att_list.filter(a => a.division_att_id !== row.division_att_id));
        deleteDivisionAttribute(row.division_id, row.division_att_id).then(resp => {
            if (resp.errorCode !== undefined || !resp.success) {
                alert(resp.message || `Error: ${resp.errorCode}`);
                setDivisionAttributes(row.division_id, att_list);
            } else {
                alert("Attribute deleted successfully!");
            }
            setStatus(DataLoadingStatus.Loaded);
        });
    }, [att_list, row, setDivisionAttributes, setStatus]);

    return (
        <div className="attributes-entry">
            <div className="attributes-data-container">
                <p className="attributes-name">{row.attribute_name}</p>
            </div>
            <button id={`h-delete-btn-${row.division_att_id}`} className="attributes-action-button" aria-label="Delete" title="Delete" onClick={deleteAttribute}><FontAwesomeIcon icon={faTrash}/></button>
        </div>
    );
}

export default memo(AttributeRow);